<template>
  <div class="jura-impressum">
    <b-container>
        <b-row class="section">
            <b-col>
              <h2>Impressum - Angaben nach § 5 TMG:</h2>
              <h3>Adresse:</h3>
              <p>Malerfach-und Stuckateurbetrieb,<br>Rüdiger Jura,<br>Richard-Wagner-Str. 13,<br>66265 Heusweiler</p>
              <h3>Vertreten durch:</h3>
              <p>Herrn Rüdiger Jura</p>
              <h3>Kontakt:</h3>
              <p>Tel. +49 (0) 6806 93 11 15,<br>Fax +49 (0) 6806 60 95 52,<br>E-Mail: info@maler-jura.de</p>
              <h3>Registereintrag:</h3>
              <p>Eintragung in der Handwerksrolle Liste B gem., §7.1 HWO mit Datum vom 26.01.2007</p>
              <h3>Umsatzsteuer:</h3>
              <p>USt-Identifikationsnummer nach §27a UStG: DE 252676532</p>
              <h3>Angaben zur Berufshaftpflichtversicherung</h3>
              <p>
                Betriebshaftpflichtversicherung Saarland Feu­er­ver­si­che­rung AG, 66111 Saarbrücken<br>
                Maler, Trockenbau, Verputz inkl. Isolierdämmung ( bis zu 10% vom Umsatz p.a.), Versicherungssumme pauschal  für Personen-, Sach- und Vermögensschäden 5.000.000 €, Umwelthaftpflichtversicherung pauschal für Personen- und Sachschäden 5.000.000 €
                <br>BG Bau 10.701.715.219 (alt 73/403-8360-3)<br>
                Betriebsnummer  15844063
              </p>
              <h3>Behördliche Zulassung</h3>
              <p>Handwerkskammer des Saarlandes,  Hohenzollernstr. 47-49, 66117 Saarbrücken, www.hwk-saarland.de <br><br>
              Gewerbeamt Gemeinde Heusweiler, Saarbrücker Str. 35, 66265 Heusweiler, www.heusweiler.de </p>
              <h3>EU-Streitschlichtung</h3>
              <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              Haftung für Inhalte
              Als Dienstanbieter sind wir nach § 7 Abs.1 Telemediengesetz (TMG) für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Dienstanbieter aber nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen..
              </p>

              <h3>Urheberrecht</h3>
              <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch.
              </p>
            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'start',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.jura-impressum {
  padding: 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Impressum.vue